<template>
  <DashboardLayout>
    <div class="d-flex align-items-center gap-2 mb-4 page-identifier">
      <p class="mb-0 main-identifier fw-semibold">Consultants</p>
      <span class="material-symbols-outlined">keyboard_arrow_right</span>
      <p class="mb-0 sub-identifier">Create New Consultant</p>
    </div>

    <div class="d-flex justify-content-center">

      <div class="form-outer">
        <form @submit.prevent="handleSubmit()">
          <div class="crud-form position-relative">

            <div class="form-inner mb-2">
              <div class="form-header d-flex justify-content-between align-items-center report">
                <div>
                  <h1 class="mb-0">Create New Consultant</h1>
                  <p class="mb-0 text-white small">Fill in the professional and banking details to onboard a new
                    consultant into the system.</p>
                </div>
              </div>

              <div class="header-box d-flex justify-content-between align-items-center mb-3">
                <div class="progress-bar" :style="{
                  '--progress-width': progressWidth,
                  '--step-count': totalSteps
                }">
                  <div class="step-icon" v-for="(s, i) in totalSteps" :key="'icon-' + i">
                    <div :class="['step', { active: step === i + 1, completed: step > i + 1 }]">
                      {{ step > i + 1 ? '✓' : i + 1 }}
                    </div>
                  </div>

                  <div class="progress-line" :style="{ '--progress-width': progressWidth }" />

                  <div class="step-label text-wrap" v-for="(s, i) in steps" :key="'label-' + i"
                    :class="{ active: step === i + 1 }">
                    {{ s.label }}
                  </div>
                </div>
              </div>


              <div class="form-body">
                <div>
                  <div class="top-section-border mb-4">
                    <div class="row mb-3">
                      <div class="col-md-6 form-group">
                        <label class="form-label mb-2">Consultant Name</label>
                        <input type="text" class="form-control" v-model="form.consultantName"
                          placeholder="Enter Consultant Name" required />
                      </div>

                      <div class="col-md-6 form-group">
                        <label class="form-label mb-2">Address <span class="text-muted">(Optional)</span></label>
                        <input type="text" class="form-control" v-model="form.address"
                          placeholder="Enter Address" />
                      </div>

                      <!-- COMMENTED OUT - Registration Number -->
                      <!--
                      <div class="col-md-6 form-group">
                        <label for="paymentType" class="form-label mb-2">Registration Number</label>
                        <input type="text" class="form-control" v-model="form.registrationNumber"
                          placeholder="Enter Registration Number" required />
                      </div>
                      -->
                    </div>

                    <!-- COMMENTED OUT - Category and TIN Row -->
                    <!--
                    <div class="row mb-3">
                      <div class="col-md-6 form-group">
                        <label class="form-label mb-2">Category</label>
                        <input type="text" class="form-control" v-model="form.category" placeholder="Enter Category"
                          required />
                      </div>

                      <div class="col-md-6 form-group">
                        <label for="paymentType" class="form-label mb-2">Tax Identification Number (TIN)</label>
                        <input type="text" class="form-control" v-model="form.taxIdentificationNumber"
                          placeholder="Enter Tax Identification Number" required />
                      </div>
                    </div>
                    -->

                    <!-- COMMENTED OUT - Bank and Account Number Row -->
                    <!--
                    <div class="row mb-3">
                      <div class="col-md-6 form-group">
                        <label for="bank" class="form-label mb-2">Bank</label>
                        <select class="form-select" v-model="form.bank" required>
                          <option value="" disabled>- Select Bank -</option>
                          <option v-for="bank in banks" :key="bank.id" :value="bank.id">{{ bank.name }}</option>
                        </select>
                      </div>

                      <div class="col-md-6 form-group">
                        <label for="accountNumber" class="form-label mb-2">Account Number</label>
                        <input type="text" class="form-control" v-model="form.accountNumber"
                          placeholder="Enter Account Number" required />
                        <div v-if="form.accountNumber && !isValidAccountNumber(form.accountNumber)"
                          class="form-text text-danger">Please ensure the account number is correct to avoid payment
                          issues.</div>
                        <div v-else-if="form.accountNumber && isValidAccountNumber(form.accountNumber)"
                          class="form-text text-success">{{ form.accountName }}</div>
                      </div>
                    </div>
                    -->
                  </div>
                </div>

                <!-- COMMENTED OUT - Step 2 Section -->
                <!--
                <div v-if="step === 2">
                  <div class="top-section-border mb-4">
                    <div class="row mb-3">
                      <div class="col-md-12 form-group">
                        <label class="form-label mb-2">Supporting Documents</label>
                        <textarea type="upload" class="form-control" v-model="form.supportingDocuments"
                          placeholder="Enter Supporting Documents" required />
                      </div>

                      <div class="col-md-12 form-group">
                        <label class="form-label mb-2">Uploaded Documents</label>
                        <textarea type="upload" class="form-control" v-model="form.uploadedDocuments"
                          placeholder="Enter Uploaded Documents" required />
                      </div>

                    </div>
                  </div>
                </div>
                -->

              </div>

              <!-- Submit Button -->
              <div class="mt-4">
                <div class="d-flex justify-content-center gap-3">
                  <button type="submit" class="btn btn-primary submit-btn" :disabled="loading">

                    <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status"
                      aria-hidden="true"></span>

                    {{ (loading ? 'Submitting...' : 'Submit') }}
                  </button>

                </div>
              </div>

            </div>


          </div>
        </form>
      </div>
    </div>

  </DashboardLayout>
</template>

<script setup>
import { ref, onMounted, computed, reactive } from 'vue'
import axios from 'axios'
import DashboardLayout from '../layout/DashboardLayout.vue'
import Swal from 'sweetalert2'
import Cookies from 'js-cookie';

const root_api_url = process.env.VUE_APP_API_ROOT_URL

const totalSteps = 1
const step = ref(1)
const steps = [
  { label: 'Consultant Information' },
]

const progressWidth = computed(() => {
  const total = steps.length
  const percentPerStep = 100 / total
  return (step.value * percentPerStep) + '%'
})

const loading = ref(false)

const form = reactive({
  consultantName: '',
  address: '',
  // COMMENTED OUT - Fields to be enabled later
  // accountNumber: '',
  // bank: '',
  // registrationNumber: '',
  // category: '',
  // taxIdentificationNumber: '',
  // supportingDocuments: '',
  // uploadedDocuments: '',
  // accountName: 'FEMI OLA'
})

const handleSubmit = async () => {
  const token = Cookies.get('auth_token');

  const iconHtmlSuccess = `<span class="iconify" data-icon="ci:circle-check" style="font-size: 100px; color: green;"></span>`
  const iconHtmlError = `<span class="iconify" data-icon="material-symbols:cancel-outline-rounded" style="font-size: 100px; color: red;"></span>`

  const consultantData = {
    name: form.consultantName,
    address: form.address,
  };
  loading.value = true;

  try {
    const result = await axios.post(`${root_api_url}/payment/consultant`, consultantData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (result.status >= 200 && result.status < 300) {
      await Swal.fire({
        html: `${iconHtmlSuccess} <h1 style="font-weight:600;">Success</h1> <p>Consultant Created Successfully</p> `,
        showConfirmButton: true,
        showCloseButton: true,
        icon: undefined,
      });
      form.consultantName = '';
      form.address = '';
    }
  } catch (error) {
    // Swal.fire({
    //   html: `${iconHtmlError}
    //   <h1 style="font-weight:600;">Error</h1>
    //   <p>Failed to create approval authority</p>`,
    //   showConfirmButton: true,
    //   showCloseButton: true,
    //   icon: undefined,
    // });
    // console.error('Submission error:', err)
    // alert('Failed to create MDA: ' + (err.response?.data?.message || err.message))

    if (error.response) {
      Swal.fire({
        html: `${iconHtmlError}
        <h1 style="font-weight:600;">Error</h1>
        <p>${error?.response?.data?.errorMessage || error?.response?.data?.error || 'Failed to create consultant'}</p>`,
        showConfirmButton: true,
        showCloseButton: true,
        icon: undefined,
      });
    } else {
      Swal.fire({
        html: `${iconHtmlError}
        <h1 style="font-weight:600;">Error</h1>
        <p>Unexpected error occurred. Kindly contact administrator</p>`,
        showConfirmButton: true,
        showCloseButton: true,
        icon: undefined,
      });
    }
  } finally {
    loading.value = false; // Stop loading
  }
}



onMounted(() => {
  document.title = "Create New Consultant"
})

</script>
<style scoped>
.view-item,
.form-inner,
.form-body {
  overflow: visible !important;
}

.material-symbols-outlined {
  font-size: 1.25rem;
}
</style>
